import { Injectable } from '@angular/core';
import { ToastrService, ToastrConfig } from 'ngx-toastr';
import { MixpanelService } from './mixpanel.service';
import { CustomConfig } from '@app/utils/toaster.config';

@Injectable()
export class ApiErrorService {

  // Safely unwrap returned JSON and pile it into a uniform & Typed array
  private static _unwrap(error): Array<ResponseError> {
    if (!error || !error._body || typeof error._body !== 'string') {
      return [];
    }

    let body: any;

    try {
      body = JSON.parse(error._body);
    } catch (e) {
      console.error(e);
      return [];
    }

    if (!body || !body.errors || !body.errors.indexOf) {
      return [];
    }

    let errors: Array<ResponseError> = [];

    for (let err of body.errors) {
      if (err.errorCode && typeof err.errorCode === 'string'
       && err.errorDescription && typeof err.errorDescription === 'string') {
        errors.push(err);
      }
    }

    return errors;
  }

  constructor(
    private mixpanelService: MixpanelService,
    private toaster: ToastrService) { }

  private _lookup(err: ResponseError): UserError {
    // Add in any known api error messages here!
    switch (err.errorCode + ': ' + err.errorDescription) {
      case ('ServerError: Status code = Conflict'):

      let analyticsObject = {
        Definition: 'LO is accessing loan while customer is using CLPBP',
        Product: 'P',
        User: 'B',
        Experience: 'O'
      };

      this.mixpanelService.track('LO Accessing Loan', analyticsObject);

      return {
        code: 'Oops! There seems to be a problem',
        description: 'It appears that your Loan Consultant (or their assistant) ' +
        'has your loan open and is reviewing your loan at this time. ' +
        'As a result, we cannot save any changes that you are making. ' +
        'Before continuing, please contact your Loan Consultant, or try again shortly.'
      };
      case ('ServerError: auth failed'):
      return {
        code: 'Oops! There seems to be a problem',
        description: 'Your password is incorrect.'
      };
      default:
      // generic error
      return {
        code: 'Oops! There seems to be a problem',
        description: 'Please try again later'
      };
    }
  }

  public toast(err): void {
    const toasts: UserError[] = ApiErrorService._unwrap(err).map(error => this._lookup(error));
    for (let toast of toasts) {
      this.toaster.error(toast.description, toast.code, CustomConfig);
    }
  }
}

export interface ResponseError {
  errorCode: string;
  errorDescription: string;
}

export interface UserError {
  code: string;
  description: string;
}

export interface ToastSignature {
  message?: string;
  title?: string;
  config?: ToastrConfig;
}
